import AnimatedLetters from '../AnimatedLetters'
import Experience from './Experience'
import './index.scss'
import { useEffect, useState } from 'react'
import Resume from './EshanPrakashResumeUpdated2024.pdf'


const About = () => {

    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        let timeout = setTimeout(() => {
            setLetterClass("text-animate-hover");
        }, 3000);
       
        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div className='container about-page'>
            <div className='text-zone'>
                <h1>
                    <AnimatedLetters 
                        letterClass={letterClass}
                        strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
                        idx={15}
                    />
                </h1>
                <p>My name is Eshan Prakash. I am a sophomore Computer Science/Cognitive Science student at Occidental College. I am interested in a number of different Computer Science fields, such as Machine Learning, Web Development, Data Analysis, and Game Development</p>
                <p>I have experience in a number of different coding languages. These include but are not limited to Python (Pandas, Bokeh, Scikit-Learn), GDScript, Java, SQL, ReactJS, HTML, PHP, CSS and Sass.</p>
                <p>Currently, I am conducting Urban Environmental Policy research under the guidance of Professor Li, Department Chair of Occidental College's Computer Science department.</p>
                <a target ='_blank' href={Resume} className='flat-button'>RÉSUMÉ</a>
            </div>
            <Experience/>
        </div>
    )

}

export default About